export default class ApiUrl {
    static GET_PASSWORD_WIKI = 'https://wiki.abc-elearning.org/wp-json/passemall/v1/reset-password';
    static GET_PASSWORD_DASHBOARD = 'https://dashboard-api2.abc-elearning.org/reset-password';
    static GET_PASSWORD_CMS = 'https://micro-enigma-235001.appspot.com/api/auth?type=reset-password';
    static GET_PASSWORD_HERO = 'https://hero-api.abc-elearning.org/reset-password';
}